import ajaxRequest from 'utils/_ajax-request.js'
import { convertDateToUTC } from 'utils/_convert_date.js'
import updateOrderListFrontend from 'utils/_update-order-list.js'
import updateUserListFrontend from 'utils/_update-user-list.js'
import updateAccountOrderListFrontend from 'utils/_update-account-order-list.js'
import updateInvoiceListFrontend from 'utils/_update-invoice-list.js'


const makeFilterParams = (formElement) => {
  let formData = new FormData(formElement)

  let searchParams = new URLSearchParams(window.location.search);

  if( searchParams.has('sorts[0][field]') ) {
    formData.append('sorts[0][field]', searchParams.get('sorts[0][field]'));
    formData.append('sorts[0][order]', searchParams.get('sorts[0][order]'));
  }

  if( searchParams.has('sorts[1][field]') ) {
    formData.append('sorts[1][field]', searchParams.get('sorts[1][field]'));
    formData.append('sorts[1][order]', searchParams.get('sorts[1][order]'));
  }

  if( searchParams.has('order_id') ) {
    searchParams.delete('order_id')
  }

  if( searchParams.has('user_id') ) {
    searchParams.delete('user_id')
  }


  const periodFromElement = document.getElementById('order_filter_period_from')
  const periodToElement = document.getElementById('order_filter_period_to')

  if( periodFromElement && periodFromElement._flatpickr.latestSelectedDateObj ) {
    formData.set('filters[period_from]', convertDateToUTC( Math.floor(periodFromElement._flatpickr.latestSelectedDateObj.getTime() / 1000) ) );
  }

  if( periodToElement && periodToElement._flatpickr.latestSelectedDateObj ) {
    formData.set('filters[period_to]', convertDateToUTC( Math.floor(periodToElement._flatpickr.latestSelectedDateObj.getTime() / 1000) ) );
  }

  const queryString = new URLSearchParams(formData).toString()

  return queryString
}


let afterUpdateInvoiceList = (xhr, error) => {
  if( error ) {
    return false
  }
  let data = JSON.parse(xhr.responseText)
  updateInvoiceListFrontend(data)
}


let updateInvoiceList = (formElement) => {
  //console.log('updateOrderList')
  let queryString = makeFilterParams(formElement)
  const new_URL = window.location.pathname + '' + '?' + queryString
  window.history.replaceState( {} , '', new_URL )
  const url = '/ru/admin/invoices/list-ajax' + '?' + queryString
  ajaxRequest(afterUpdateInvoiceList, url, {}, 'GET')
}


let afterUpdateAccountOrderList = (xhr, error) => {
  if( error ) {
    return false
  }
  let data = JSON.parse(xhr.responseText)
  updateAccountOrderListFrontend(data)
}


let updateAccountOrderList = (formElement) => {
  //console.log('updateAccountOrderList')
  let queryString = makeFilterParams(formElement)
  const new_URL = window.location.pathname + '' + '?' + queryString
  window.history.replaceState( {} , '', new_URL )
  const url = window.location.pathname + 'list-ajax' + '?' + queryString
  ajaxRequest(afterUpdateAccountOrderList, url, {}, 'GET')
}




let afterUpdateOrderList = (xhr, error) => {
  if( error ) {
    return false
  }
  let data = JSON.parse(xhr.responseText)
  updateOrderListFrontend(data)
}


let updateOrderList = (formElement) => {
  //console.log('updateOrderList')
  let queryString = makeFilterParams(formElement)
  const new_URL = window.location.pathname + '' + '?' + queryString
  window.history.replaceState( {} , '', new_URL )
  const url = window.location.pathname + 'list-ajax' + '?' + queryString
  ajaxRequest(afterUpdateOrderList, url, {}, 'GET')
}



let afterUpdateUserList = (xhr, error) => {
  if( error ) {
    return false
  }
  let data = JSON.parse(xhr.responseText)
  updateUserListFrontend(data)
}

let updateUserList = (formElement) => {
  //console.log('updateUserList')
  let queryString = makeFilterParams(formElement)
  const new_URL = window.location.pathname + '' + '?' + queryString
  window.history.replaceState( {} , '', new_URL )
  const url = window.location.pathname + 'list-ajax' + '?' + queryString
  ajaxRequest(afterUpdateUserList, url, {}, 'GET')
}


let updateListHandler = (type, formElement) => {
  if( type === 'admin-order-list' ) {
    updateOrderList(formElement)
  }
  else if( type === 'admin-user-list' ) {
    updateUserList(formElement)
  }
  else if( type === 'account-order-list' ) {
    updateAccountOrderList(formElement)
  }
  else if( type === 'admin-invoice-list' ) {
    updateInvoiceList(formElement)
  }
}


/**
 * @param {string} buttonId
 * @param {string} formId
 * @param {string} resetId
 * @param {string} reloadId
 */

export default (
  buttonId,
  formId,
  resetId,
  reloadId
) => {

  const filterButton = document.getElementById(buttonId)
  if (!filterButton) {
    return
  }

    const formElement = document.getElementById(formId);
  if (!formElement) {
    return
  }

  let type = ''

  if( document.querySelector('.personal-area__filter-wrapper') ) {
    type = 'admin-user-list'
  }
  else if( document.querySelector('.filter-admin-order-list__filter-wrapper') ) {
    type = 'admin-order-list'
  }
  else if( document.querySelector('.filter-account-order-list__filter-wrapper') ) {
    type = 'account-order-list'
  }
  else if( document.querySelector('.filter-admin-invoice-list__filter-wrapper') ) {
    type = 'admin-invoice-list'
  }

  //console.log(type)

  let inputs = document.querySelectorAll('#filter-form input')
  inputs.forEach((item) => {
    item.addEventListener('change', () => {
      //console.log('change')

      updateListHandler(type, formElement)
    })
  })


  let customerFirstChange = true
  let designerFirstChange = true

  if (window.jQuery) {
    $(document).ready(function(){
      $('#customer-select').on('change', function (e) {
        if( customerFirstChange ) {
          customerFirstChange = false
        }
        else {
          //console.log('change.select2')

          updateListHandler(type, formElement)
        }
      });

      $('#designer-select').on('change', function (e) {
        if( designerFirstChange ) {
          designerFirstChange = false
        }
        else {
          //console.log('change.select2')

          updateListHandler(type, formElement)
        }
      });
    })
  }


  filterButton.addEventListener('click', (event) => {
    event.preventDefault();

    //updateOrderList(formElement)

    //let queryString = makeFilterParams(formElement)

    //window.location.href = window.location.protocol + "//" + window.location.host + "" + window.location.pathname + '?' + queryString;
    //return false;

    let formData = new FormData(formElement)

    let searchParams = new URLSearchParams(window.location.search);

    if( searchParams.has('sorts[0][field]') ) {
      formData.append('sorts[0][field]', searchParams.get('sorts[0][field]'));
      formData.append('sorts[0][order]', searchParams.get('sorts[0][order]'));
    }

    if( searchParams.has('sorts[1][field]') ) {
      formData.append('sorts[1][field]', searchParams.get('sorts[1][field]'));
      formData.append('sorts[1][order]', searchParams.get('sorts[1][order]'));
    }

    if( searchParams.has('order_id') ) {
      searchParams.delete('order_id')
    }

    if( searchParams.has('user_id') ) {
      searchParams.delete('user_id')
    }


    const periodFromElement = document.getElementById('order_filter_period_from')
    const periodToElement = document.getElementById('order_filter_period_to')

    if( periodFromElement && periodFromElement._flatpickr.latestSelectedDateObj ) {
      //formData.set('filters[period_from]', Math.floor(periodFromElement._flatpickr.latestSelectedDateObj.getTime() / 1000));

      /*let timestamp = Math.floor(periodFromElement._flatpickr.latestSelectedDateObj.getTime() / 1000)
      console.log(timestamp)
      var a = dayjs.unix(timestamp)

      let dateTz = a.tz("UTC", true)
      console.log(dateTz.format('YYYY-MM-DD HH:mm:ss'))
      console.log(dateTz.unix())*/

      formData.set('filters[period_from]', convertDateToUTC( Math.floor(periodFromElement._flatpickr.latestSelectedDateObj.getTime() / 1000) ) );

      //return

    }

    if( periodToElement && periodToElement._flatpickr.latestSelectedDateObj ) {
      //formData.set('filters[period_to]', Math.floor(periodToElement._flatpickr.latestSelectedDateObj.getTime() / 1000));

      formData.set('filters[period_to]', convertDateToUTC( Math.floor(periodToElement._flatpickr.latestSelectedDateObj.getTime() / 1000) ) );
    }


    const queryString = new URLSearchParams(formData).toString()

    //const queryString = makeFilterParams(formElement)

    window.location.href = window.location.protocol + "//" + window.location.host + "" + window.location.pathname + '?' + queryString;
  })


  const resetButton = document.getElementById(resetId)
  if (!resetButton) {
    return
  }

  resetButton.addEventListener('click', (event) => {
    event.preventDefault();

    let elements = formElement.getElementsByTagName("input");
    elements = Array.from(elements);
    elements.forEach((item) => {
      if (item.type == "text") {
        item.value = "";
      }
      else if( item.type == "checkbox" ) {
        item.checked = false;
      }
    })

    let selects = formElement.getElementsByTagName("select");
    selects = Array.from(selects);
    selects.forEach((item) => {
      item.selectedIndex = -1;
    })


    let formData = new FormData(formElement)
    const queryString = new URLSearchParams(formData).toString()
    window.location.href = window.location.protocol + "//" + window.location.host + "" + window.location.pathname + '?' + queryString;
  })


  const reloadButton = document.getElementById(reloadId)
  if( reloadButton ) {
    reloadButton.addEventListener('click', (event) => {
      event.preventDefault();

      //window.location.reload()

      let searchParams = new URLSearchParams(window.location.search);

      if( searchParams.has('order_id') ) {
        searchParams.delete('order_id')
      }

      if( searchParams.has('user_id') ) {
        searchParams.delete('user_id')
      }

      window.location.href = window.location.protocol + "//" + window.location.host + "" + window.location.pathname + '?' + searchParams.toString();
    })
  }
}

